const validateNumber = (value: any) => {
  if (value === undefined || value === null || value === "") return;
  if (!/^\d*\.?\d{0,2}$/.test(value)) {
    return "Please enter a valid number (up to two decimal places)";
  }
};

export default validateNumber;
